import React from 'react';
import './TentSolutions.css';

const TentSolutions = () => {
  return (
    <section className="tent-solutions">
      <div className="solutions-container">
        <h2>Discover our premium tent solutions for every occasion</h2>
        <p className="solutions-description">
          We specialize in high-quality tents for accommodation, events, utilities, and custom needs. Our tents provide
          durable shelter, elegant event setups, functional workspaces, and branded designs for businesses, all crafted from
          premium materials for durability, weather resistance, and versatility.
        </p>

        <div className="solutions-grid">
          <div className="solution-card">
            
            <div className="solution-image">
              <img src="/images/angata-camps-4.jpg" alt="Event Tent" />
            </div>
            <button className="solution-button">Event Tents</button>
            <div className="underline"></div>
            <p>
              Perfect for weddings, corporate events, exhibitions, and special occasions. These tents are elegant, spacious, and weather-resistant! Built with durability and stability, they provide a comfortable and elegant atmosphere, with customizable layouts for dance floors, sidewalls, styling, and theming to suit any event theme and requirement.
            </p>
          </div>

          <div className="solution-card">
            
            <div className="solution-image">
              <img src="/images/Camp-Tent-View.jpeg" alt="Custom Tent" />
            </div>
            <button className="solution-button">Custom Tents</button>
            <div className="underline"></div>
            <p>
              Custom tents offer versatility, personalization, and high-quality craftsmanship in every detail. Whether used for corporate promotions, special events, or unique structural needs, they can be tailored in size, design, branding, and features. Made from premium and durable materials, they provide both functionality and visual appeal.
            </p>
          </div>

          <div className="solution-card">
            
            <div className="solution-image">
              <img src="/images/accomodation.JPG" alt="Accommodation Tent" />
            </div>
            <button className="solution-button">Accommodation Tents</button>
            <div className="underline"></div>
            <p>
              Designed for comfort, durability, and adaptability in various environments. Whether for camping, staff housing, remote work sites, or emergency accommodation, these spacious, weather-resistant living spaces. Made from high-quality materials, they offer protection against harsh weather conditions while ensuring ventilation and come in various customizable sizes and configurations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TentSolutions; 